import { render, staticRenderFns } from "./Schulungsunterlagen.vue?vue&type=template&id=5bb2af08"
import script from "./Schulungsunterlagen.vue?vue&type=script&lang=js"
export * from "./Schulungsunterlagen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports